// extracted by mini-css-extract-plugin
module.exports = {"sale":"styles_sale__3xg3L","saleText":"styles_saleText__2PHSo"};